import './StockMarketMantra.css'
import React, { useState, useEffect, useRef } from 'react'
import StockMarketMantraList from '../../Data/StockMarketMantra'
import SmmCard from './Component/SmmCard'
import SectionIds from '../../Helper/SectionId'
import { useInView } from 'framer-motion'
import AssetImage from '../../Helper/AssetImage'
import AssetImages from '../../Helper/AssetImages'
import SectionWithAnalytics from '../../Components/sectionWithAnalytics'
export default function StockMarketMantra() {
  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const [pauseTimer, setPauseTimer] = useState(false);
  const sectionRef = useRef(null);
  const inView = useInView(sectionRef);

  useEffect(() => {

    if (inView) {
      setActiveCardIndex(0);
      setPauseTimer(false);
    }
    else
      setPauseTimer(true)


  }, [inView])
  useEffect(() => {

    const timer = setInterval(
      () => {

        if (!pauseTimer) {

          setActiveCardIndex(prevIndex => {

            if (prevIndex === StockMarketMantraList.length - 1) {
              return 0;
            }
            else {
              return prevIndex + 1;
            }
          })
        }
      }, 2000
    );
    return () => clearInterval(timer)

  }, [pauseTimer])

  return (
    <SectionWithAnalytics className='section section-smm ' id={SectionIds.sectionStockMarketMantra} ref={sectionRef}>
      <div className="header container-vertical res-gap-8 align-center">
        <div className='fs-medium fw-semibold clr-primary text-align-center '>
          Remember
        </div>
        <h3>
          Stock Market <mark>Mantra</mark>
        </h3>
      </div>

      <AssetImage className="illustration" assetImage={AssetImages.illustrationStockMarketMantra} />

      <ul className='content-grid res-gap-16'>
        {
          StockMarketMantraList.map((element, index) => {
            return <SmmCard
              key={index}
              title={element.title}

              content={element.content}

              isActive={activeCardIndex === index}

              onMouseEnter={() => {
                setActiveCardIndex(index)
                setPauseTimer(true)
              }}
              onMouseLeave={() => {
                setPauseTimer(false)
              }}
            />
          })
        }
      </ul>
    </SectionWithAnalytics>
  )
}
